import { useState } from 'react';

/**
 * Generic collapsed-by-default accordion section — header (label + count) toggles a
 * body. Used for the "Closed" section on Programs/Components/Goals list pages, PM
 * Home's Assigned Programs, and Supplier Portal's Current Status, so there's one
 * shared collapse mechanic instead of independently-hand-rolled copies on each page.
 * Props: `label`, `count` (optional badge number), `defaultOpen` (default false),
 * `bodyStyle` (override the body wrapper's padding — pass `{ padding: 0 }` when
 * wrapping something that already has its own padding, e.g. DataTable).
 */
export default function CollapsibleSection({ label, count, defaultOpen = false, bodyStyle, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginTop: '12px', border: '1px solid #e8ecef', borderRadius: '8px', overflow: 'hidden' }}>
      <div onClick={() => setOpen(o => !o)}
        style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: '#f8f9fa', borderBottom: open ? '1px solid #e8ecef' : 'none' }}>
        <span style={{ fontSize: '11px', color: '#888' }}>{open ? '▼' : '▶'}</span>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>{label}</span>
        {count != null && (
          <span style={{ background: '#e8ecef', color: '#555', borderRadius: '10px', padding: '1px 8px', fontSize: '11px' }}>
            {count}
          </span>
        )}
      </div>
      {open && <div style={{ padding: '12px 14px', ...bodyStyle }}>{children}</div>}
    </div>
  );
}
